export default "__VITE_ASSET__a00d6f08__"